import React, { useCallback, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
interface BeforeAfterSliderProps {
  antes: string;
  depois: string;
  alt: string;
}
export function BeforeAfterSlider({
  antes,
  depois,
  alt
}: BeforeAfterSliderProps) {
  const [posicao, setPosicao] = useState(50);
  const [arrastando, setArrastando] = useState(false);
  const areaRef = useRef<HTMLDivElement>(null);
  const atualizar = useCallback((clientX: number) => {
    const area = areaRef.current;
    if (!area) return;
    const rect = area.getBoundingClientRect();
    const pct = (clientX - rect.left) / rect.width * 100;
    setPosicao(Math.min(100, Math.max(0, pct)));
  }, []);
  const onPointerDown = (event: React.PointerEvent<HTMLDivElement>) => {
    event.stopPropagation();
    event.currentTarget.setPointerCapture(event.pointerId);
    setArrastando(true);
    atualizar(event.clientX);
  };
  const onPointerMove = (event: React.PointerEvent<HTMLDivElement>) => {
    if (!arrastando) return;
    event.stopPropagation();
    atualizar(event.clientX);
  };
  const encerrar = (event: React.PointerEvent<HTMLDivElement>) => {
    if (event.currentTarget.hasPointerCapture(event.pointerId)) {
      event.currentTarget.releasePointerCapture(event.pointerId);
    }
    setArrastando(false);
  };
  const onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      setPosicao(p => Math.max(0, p - 5));
    }
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      setPosicao(p => Math.min(100, p + 5));
    }
  };
  return <div ref={areaRef} onPointerDown={onPointerDown} onPointerMove={onPointerMove} onPointerUp={encerrar} onPointerCancel={encerrar} className="relative h-56 w-full touch-pan-y select-none overflow-hidden rounded-2xl bg-sand" data-id="element-24" data-mp="21btiehqte7n2">
      <img src={depois} alt={`${alt} — depois`} draggable={false} className="pointer-events-none absolute inset-0 h-full w-full object-cover" data-id="element-25" data-mp="bv27t96x3q98" />
      <img src={antes} alt={`${alt} — antes`} draggable={false} className="pointer-events-none absolute inset-0 h-full w-full object-cover" style={{
      clipPath: `inset(0 ${100 - posicao}% 0 0)`
    }} data-id="element-26" data-mp="3vyyft9nrvca1" />

      <span className="pointer-events-none absolute bottom-3 left-3 rounded-full bg-ink/75 px-2.5 py-1 text-[10px] font-medium uppercase tracking-[0.18em] text-cream" data-id="element-27" data-mp="8t7ix11r6fec">
        Antes
      </span>
      <span className="pointer-events-none absolute bottom-3 right-3 rounded-full bg-cream/90 px-2.5 py-1 text-[10px] font-medium uppercase tracking-[0.18em] text-ink" data-id="element-28" data-mp="irdi3aw6d7fi">
        Depois
      </span>

      <div role="slider" tabIndex={0} aria-label="Comparar antes e depois" aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(posicao)} aria-valuetext={`${Math.round(posicao)}% do antes visível`} onKeyDown={onKeyDown} className="absolute inset-y-0 -ml-5 w-10 cursor-ew-resize focus-visible:outline-none" style={{
      left: `${posicao}%`
    }} data-id="element-29" data-mp="rlrvf7x5a7vz">
        <span className="absolute inset-y-0 left-1/2 w-[2px] -translate-x-1/2 bg-cream" data-id="element-30" data-mp="1p3xdxtcpcak2" />
        <span className="absolute left-1/2 top-1/2 flex h-10 w-10 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-cream text-ink shadow-card" data-id="element-31" data-mp="1b8cxr5ocy6gc">
          <ChevronLeftIcon className="h-3.5 w-3.5" strokeWidth={2} data-id="element-32" data-mp="11fnpejo3t8p8" />
          <ChevronRightIcon className="h-3.5 w-3.5" strokeWidth={2} data-id="element-33" data-mp="167p9usvfe5qc" />
        </span>
      </div>
    </div>;
}